import { useEffect, useState } from "react";
export var useGetPermissionList = function (trigger) {
    var _a = useState([]), permissionList = _a[0], setPermissionList = _a[1];
    var getAllPermissions = function (roles) {
        return roles === null || roles === void 0 ? void 0 : roles.reduce(function (acc, role) {
            return acc.concat(role.permissions);
        }, []);
    };
    useEffect(function () {
        var _a, _b, _c;
        if (trigger) {
            try {
                var storedLogin = localStorage.getItem("assurehub");
                var parsed = storedLogin ? JSON.parse(storedLogin) : {};
                // Intentar ambas estructuras: parsed.roles o parsed.user.roles
                var roles = (_c = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.roles) !== null && _a !== void 0 ? _a : (_b = parsed === null || parsed === void 0 ? void 0 : parsed.user) === null || _b === void 0 ? void 0 : _b.roles) !== null && _c !== void 0 ? _c : [];
                setPermissionList(getAllPermissions(roles));
            }
            catch (error) {
                console.error("Error loading permissions:", error);
                setPermissionList([]);
            }
        }
    }, [trigger]);
    return {
        permissionList: permissionList,
    };
};
